import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

import Table from '../../../components/table/Table';
import addNotification from '../../../components/notification';
import FormatHelpers from '../../../helpers/format';
import AllocationRulesHelper from '../../../helpers/outboundAllocationRules';

class ModalAllocationFailureReason extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedSimulationSummary: null,
      showRulesLegend: false,
    };

    this.defaultPageSize = 3;
    this.pageSizeOptions = [3, 4, 5];

    this.addressesColumns = [{
      Header: I18n.t('BEE225' /* Produto */),
      accessor: 'productCode',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
    }, {
      Header: I18n.t('BEE182' /* Depósito */),
      accessor: 'depositCode',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 90,
    }, {
      Header: I18n.t('BEE428' /* Lote */),
      accessor: 'lotNumber',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 100,
    }, {
      Header: I18n.t('BEE434' /* Data de Validade */),
      accessor: 'expirationDate',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 130,
      Cell: (row) => (
        <span>{row.value && moment(row.value).format('L')}</span>
      ),
    }, {
      Header: I18n.t('BEE267' /* Endereço */),
      accessor: 'addressCode',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
    }, {
      Header: I18n.t('BEE530' /* Disponível */),
      accessor: 'availableQuantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 100,
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    }, {
      Header: I18n.t('BEE1431' /* Alocado */),
      accessor: 'allocatedQuantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 100,
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    }, {
      Header: 'Reservado',
      accessor: 'reservedQuantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 100,
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    }, {
      Header: 'Simulado',
      accessor: 'simulatedAllocationQuantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 100,
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    }, {
      Header: I18n.t('BEE504' /* Total */),
      accessor: 'quantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 100,
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    }, {
      Header: 'Elegível',
      accessor: 'eligibleForAllocation',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 90,
      Cell: (row) => (
        <span style={{ color: row.value ? 'green' : 'red' }}>
          {row.value ? I18n.t('BEE172' /* Sim */) : I18n.t('BEE173' /* Não */)}
        </span>
      ),
    }, {
      Header: 'Regra',
      accessor: 'allocationRule',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
    }, {
      Header: 'Motivo inelegibilidade',
      accessor: 'ineligibilityReason',
      style: { alignSelf: 'center', textAlign: 'left' },
      minWidth: 250,
    }];

    this.simulationSummaryColumns = [{
      Header: I18n.t('BEE225' /* Produto */),
      accessor: 'productCode',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
    }, {
      Header: I18n.t('BEE2727' /* Quantidade pendente */),
      accessor: 'pendingQuantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    }, {
      Header: 'Qtd. restante',
      accessor: 'remainingQuantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 120,
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    }, {
      Header: I18n.t('BEE1431' /* Alocado */),
      accessor: 'allocatedQuantity',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 100,
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    }, {
      Header: 'Endereços encontrados',
      accessor: 'addressesFound',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
    }, {
      Header: 'Endereços elegíveis',
      accessor: 'eligibleAddresses',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
    }, {
      Header: 'Endereços excluídos',
      accessor: 'excludedAddresses',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 150,
    }, {
      Header: 'Total disponível elegível',
      accessor: 'totalAvailableEligible',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 170,
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    }, {
      Header: 'Total simulado',
      accessor: 'totalSimulatedAllocation',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 130,
      Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
    }];
  }

  getAggregatedData = () => {
    const { allocationResult = {} } = this.props;
    const {
      failures = [],
      addresses = [],
      simulationSummaries = [],
      simulationSummary,
    } = allocationResult;

    const failureAddresses = failures.flatMap((failure) => failure.addresses || []);
    const failureSimulationSummaries = failures
      .map((failure) => failure.simulationSummary)
      .filter(Boolean)
      .flatMap((item) => (Array.isArray(item) ? item : [item]));

    const topLevelSimulationSummaries = [];
    if (simulationSummary) {
      if (Array.isArray(simulationSummary)) {
        topLevelSimulationSummaries.push(...simulationSummary);
      } else {
        topLevelSimulationSummaries.push(simulationSummary);
      }
    }

    const allAddresses = _.uniqBy(
      [...addresses, ...failureAddresses],
      (item) => item.stockBalanceId,
    );

    const allSimulationSummaries = _.uniqBy(
      [
        ...simulationSummaries,
        ...topLevelSimulationSummaries,
        ...failureSimulationSummaries,
      ],
      (item) => item.productCode,
    );

    return {
      addresses: allAddresses,
      simulationSummaries: allSimulationSummaries,
    };
  };

  getFilteredAddresses = (selectedSimulationSummary) => {
    const { addresses } = this.getAggregatedData();

    if (!selectedSimulationSummary) {
      return [];
    }

    return addresses.filter(
      (address) => address.productCode === selectedSimulationSummary.productCode,
    );
  };

  getSelectedSimulationSummary = () => {
    const { simulationSummaries } = this.getAggregatedData();
    const { selectedSimulationSummary } = this.state;

    if (
      selectedSimulationSummary
      && simulationSummaries.some(
        (item) => item.productCode === selectedSimulationSummary.productCode,
      )
    ) {
      return selectedSimulationSummary;
    }

    return simulationSummaries.length > 0 ? simulationSummaries[0] : null;
  };

  getProductAllocationCounts = () => {
    const { simulationSummaries } = this.getAggregatedData();

    if (!simulationSummaries.length) {
      const { allocationResult = {} } = this.props;
      return {
        amountSuccess: allocationResult.amountSuccess || 0,
        amountFail: allocationResult.amountFail || 0,
      };
    }

    let amountSuccess = 0;
    let amountFail = 0;

    simulationSummaries.forEach((summary) => {
      const simulatedAllocation = parseFloat(
        summary.totalSimulatedAllocation || summary.allocatedQuantity || 0,
      );

      if (simulatedAllocation > 0) {
        amountSuccess += 1;
      } else {
        amountFail += 1;
      }
    });

    return { amountSuccess, amountFail };
  };

  toggleRulesLegend = () => {
    this.setState((prevState) => ({
      showRulesLegend: !prevState.showRulesLegend,
    }));
  };

  setSimulationSummarySelected = (simulationSummary) => {
    this.setState({ selectedSimulationSummary: simulationSummary });
  };

  componentDidUpdate(prevProps) {
    const { openModal, allocationResult } = this.props;

    if (openModal && !prevProps.openModal) {
      const { simulationSummaries } = this.getAggregatedData();
      this.setState({
        selectedSimulationSummary: simulationSummaries.length > 0
          ? simulationSummaries[0]
          : null,
      });
      return;
    }

    if (
      openModal
      && allocationResult !== prevProps.allocationResult
    ) {
      const { simulationSummaries } = this.getAggregatedData();
      const { selectedSimulationSummary } = this.state;
      const isSelectedStillValid = selectedSimulationSummary
        && simulationSummaries.some(
          (item) => item.productCode === selectedSimulationSummary.productCode,
        );

      if (!isSelectedStillValid) {
        this.setState({
          selectedSimulationSummary: simulationSummaries.length > 0
            ? simulationSummaries[0]
            : null,
        });
      }
    }
  }

  defaultFilterMethod = (filter, row) => {
    const input = _.lowerCase(filter.value);
    const value = _.lowerCase(row[filter.id]);
    return _.includes(value, input);
  };

  closeModal = () => {
    const { isSimulation = false } = this.props;

    if (isSimulation) {
      addNotification(
        'info',
        I18n.t('BEE1857' /* Monitor de Pendências de Alocação */),
        I18n.t('BEE4682' /* Simulação finalizada! Nenhum produto foi alocado durante a simulação. */),
        'top-right',
      );
    }

    this.setState({
      selectedSimulationSummary: null,
      showRulesLegend: false,
    });
    this.props.closeModalAllocationFailureReason();
  };

  render() {
    const {
      openModal = false,
      allocationResult = {},
      isSimulation = false,
    } = this.props;

    const {
      addresses: allAddresses,
      simulationSummaries,
    } = this.getAggregatedData();

    const selectedSimulationSummary = this.getSelectedSimulationSummary();
    const filteredAddresses = this.getFilteredAddresses(selectedSimulationSummary);
    const { amountSuccess, amountFail } = this.getProductAllocationCounts();
    const hasSimulationSummaries = simulationSummaries.length > 0;
    const stockBalanceData = hasSimulationSummaries ? filteredAddresses : allAddresses;
    const showStockBalance = hasSimulationSummaries
      ? !!selectedSimulationSummary
      : allAddresses.length > 0;

    const { orderNumber } = allocationResult;
    const { showRulesLegend } = this.state;
    const allocationRulesLegend = AllocationRulesHelper.allocationRules();

    const modalTitle = isSimulation
      ? `${I18n.t('BEE600' /* Simular */)} - ${I18n.t('BEE4730' /* Motivo da não alocação */)}`
      : I18n.t('BEE4730' /* Motivo da não alocação */);

    return (
      <Modal
        isOpen={openModal}
        toggle={this.closeModal}
        style={{ maxWidth: '70vw', width: '70%' }}
      >
        <ModalHeader toggle={this.closeModal}>
          <div className="w-100 pr-5">
            <p className="mb-2">
              <strong>{modalTitle}</strong>
            </p>
            {orderNumber && (
              <p className="mb-2">
                <strong>
                  {`${I18n.t('BEE1378' /* Documento */)}: `}
                </strong>
                {orderNumber}
              </p>
            )}
            <div className="d-flex justify-content-between w-100">
              <div className="mb-0 mr-4">
                <p>
                  <strong>{`${I18n.t('BEE4732' /* Sucesso */)}: `}</strong>
                  {amountSuccess}
                </p>
              </div>
              <div className="mb-0 mr-4">
                <p>
                  <strong>{`${I18n.t('BEE4733' /* Falha */)}: `}</strong>
                  {amountFail}
                </p>
              </div>
              <div className="mb-0">
                <p>
                  <strong>{`${I18n.t('BEE4734' /* Alocação Possível */)}: `}</strong>
                  {allocationResult.allocationPossible
                    ? I18n.t('BEE172' /* Sim */)
                    : I18n.t('BEE173' /* Não */)}
                </p>
              </div>
            </div>
          </div>
        </ModalHeader>
        <ModalBody style={{ overflowX: 'auto' }}>
          <div className="mb-3 border rounded bg-light">
            <button
              type="button"
              className="btn btn-link btn-block text-left p-3 mb-0 text-dark"
              onClick={this.toggleRulesLegend}
              style={{ textDecoration: 'none' }}
            >
              <i className={`fa fa-chevron-${showRulesLegend ? 'down' : 'right'} mr-2`} />
              <strong>{I18n.t('BEE4731' /* Legenda das regras de alocação */)}</strong>
            </button>
            {showRulesLegend && (
              <div className="px-3 pb-3">
                <table className="table table-sm table-bordered mb-0 bg-white">
                  <thead>
                    <tr>
                      <th style={{ width: 90 }}>{I18n.t('BEE2684' /* Regra */)}</th>
                      <th>{I18n.t('BEE277' /* Descrição */)}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allocationRulesLegend.map((rule) => (
                      <tr key={rule.number}>
                        <td className="text-center">
                          <strong>{rule.number}</strong>
                        </td>
                        <td>{rule.label}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {hasSimulationSummaries && (
            <Table
              panelHeaderProps={{
                noButton: true,
                children: I18n.t('BEE4735' /* Resumo da Simulação */).toUpperCase(),
              }}
              filterable
              data={simulationSummaries}
              columns={this.simulationSummaryColumns}
              expander
              pageSizeOptions={this.pageSizeOptions}
              defaultPageSize={this.defaultPageSize}
              defaultFilterMethod={this.defaultFilterMethod}
              getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row) {
                  return {
                    onClick: () => {
                      this.setSimulationSummarySelected(rowInfo.original);
                    },
                    style: {
                      background: selectedSimulationSummary
                        && rowInfo.original.productCode === selectedSimulationSummary.productCode
                        ? 'silver'
                        : 'white',
                      cursor: 'pointer',
                    },
                  };
                }
                return {};
              }}
            />
          )}

          {showStockBalance && (
            <Table
              key={
                selectedSimulationSummary
                  ? selectedSimulationSummary.productCode
                  : 'stock-balance'
              }
              panelHeaderProps={{
                noButton: true,
                children: I18n.t('BEE489' /* Saldo Estoque */).toUpperCase(),
              }}
              filterable
              data={stockBalanceData}
              columns={this.addressesColumns}
              expander
              pageSizeOptions={this.pageSizeOptions}
              defaultPageSize={this.defaultPageSize}
              defaultSorted={[{ id: 'productCode', desc: false }]}
              defaultFilterMethod={this.defaultFilterMethod}
              totalDataLength={stockBalanceData.length}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-120 btn-secondary p-5 m-5"
            onClick={this.closeModal}
          >
            {I18n.t('BEE553' /* Fechar */)}
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ModalAllocationFailureReason));
